import { ref } from 'vue'
import { auth, onAuthStateChanged } from '@/firebase/config'

// refs
const user = ref(auth.currentUser)
const role = ref('')
const grade = ref('')

// listen for auth changes outside of function
// so only 1 listener is ever attached
onAuthStateChanged(auth, _user => {
  // console.log('User state change. Current user is:', _user)
  user.value = _user

  if (_user) {
    _user.getIdTokenResult()
      .then((idTokenResult) => {
        // Confirm the user is an Admin.
        if (idTokenResult.claims.role) {
          // Show admin UI.
          role.value = idTokenResult.claims.role
          grade.value = idTokenResult.claims.grade
        } else {
          // Show regular user UI.
          console.log(grade.value)
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }
})

const getUser = () => {
  return { user, role, grade }
}

export default getUser
